import React from "react"
import { useShallow } from "zustand/react/shallow"

// components
import { Space, Radio } from "antd"

// hoc
import InputWrapper from "../../hoc/InputWrapper/InputWrapper"
import useAuthoringViewStore from "../../../hooks/stores/useAuthoringViewStore"

// context
import "./RJRadio.scss"

const RJRadio = (props) => {
  let { id, schema, carbonProps, onChange, value, isTranslation, selectedLanguage, originalValue } = props

  const { formView } = useAuthoringViewStore(
    useShallow((state) => ({
      formView: state.formView,
    }))
  )

  const handleChange = (e, option) => {
    console.log("Radio useEffect >> onChange")
    let value = e.target.value
    let foundOption = option
    if (schema?.options) {
      foundOption =
        schema.options.find(
          (item) =>
            item.translations?.[selectedLanguage] === value ||
            item.label === value ||
            item?.registries?.[formView.id] === value
        ) || option
    }

    onChange(value, foundOption)
  }

  const selectedValue = React.useMemo(() => {
    if (isTranslation && originalValue && typeof value !== "object") {
      return originalValue
    } else if (value && schema?.valueMapping?.[formView?.id]?.[value]) {
      return schema?.valueMapping?.[formView?.id]?.[value]
    } else if (value && typeof value !== "object") {
      return value
    }

    return value
  }, [value, originalValue, formView?.id])

  let items = []

  if (schema.options) {
    items =
      schema.options
        ?.filter((option) => !(option?.hideInRegistries && option.hideInRegistries.includes(formView.id)))
        ?.map((option) => {
          let ret = {
            value: option.value,
            label: option.label,
          }
          if (option?.registries?.[formView.id]) {
            ret.label = option.registries[formView.id]
          }
          if (option?.translations?.[selectedLanguage]) {
            ret.label = option.translations[selectedLanguage]
          }
          return ret
        }) || []
  } else if (schema?.enum) {
    items = schema.enum.map((item) => ({ value: item, label: item }))
  }

  return (
    <>
      <Radio.Group
        disabled={carbonProps.disabled}
        onChange={handleChange}
        value={selectedValue}
        className="rjs-radio-widget"
      >
        <Space direction={carbonProps.orientation ? carbonProps.orientation : "horizontal"}>
          {items?.map((item, i) => {
            let label = item.label

            if (isTranslation && item?.translations?.[selectedLanguage]) {
              label = item.translations[selectedLanguage]
            } else if (item?.registries?.[formView.id]) {
              label = item.registries[formView.id]
            }

            return (
              <Radio
                id={id + "-" + i}
                key={id + "-" + i}
                value={item.value}
              >
                {label}
              </Radio>
            )
          })}
        </Space>
      </Radio.Group>
    </>
  )
}

export default InputWrapper(RJRadio)
